import React from "react";

const TextbooksPage = () => {
  const books = [
    {
      name: "Real Estate Principles",
      url: "/textbooks/Real_Estate_Principles_Textbook.pdf",
    },
    {
      name: "Legal Aspects Real Estate",
      url: "/textbooks/Legal_Aspects_Real_Estate__Textbook.pdf",
    },
    {
      name: "Real Estate Practice",
      url: "/textbooks/Real_Estate_Practice_Textbook.pdf",
    },
    {
      name: "Mortgage Loan Brokering",
      url: "/textbooks/Mortgage_Loan_Brokering_textbook.pdf",
    },
    {
      name: "Real Estate Economics",
      url: "/textbooks/Real_Estate_Economics_Textbook.pdf",
    },
    {
      name: "Real Estate Finance",
      url: "/textbooks/Real_Estate_Finance_Textbook.pdf",
    },
    {
      name: "Real Estate Property Management",
      url: "/textbooks/Real_Estate_Property_Management_Textbook.pdf",
    },
  ];
  return (
    <div>
      <h1 className="display-6 mb-4">PDF Textbooks</h1>
      {books.map((b, i) => (
        <a
          key={i}
          className="btn btn-lg btn-light d-block mb-3 shadow-sm text-start border"
          href={b.url}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-file-pdf"
            viewBox="0 0 16 16"
          >
            <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
            <path d="M4.603 12.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.701 19.701 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.716 5.716 0 0 1-.911-.95 11.642 11.642 0 0 0-1.997.406 11.311 11.311 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.27.27 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.647 12.647 0 0 1 1.01-.193 11.666 11.666 0 0 1-.51-.858 20.741 20.741 0 0 1-.5 1.05zm2.446.45c.15.162.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.881 3.881 0 0 0-.612-.053zM8.078 5.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
          </svg>
          <span className="align-middle"> {b.name}</span>
        </a>
      ))}
      <section className="py-5">
        <h4>Access the PDF Course Textbooks</h4>
        <h4>Listen by using “Read Out Loud” feature</h4>
        <h6>Adobe Acrobat Download Instructions</h6>

        <div className="bg-light p-4 rounded-3 mt-3">
          <h5>USING COMPUTER (laptop)</h5>
          <ul className="list-unstyled fs-6">
            <li>
              <span className="fw-semibold">Step 1.</span> Download the PDFs
              textbooks from our website and place in a folder on your computer.
            </li>

            <li>
              <span className="fw-semibold">Step 2.</span> Go to www.adobe.com
              scroll down to a box that's says: Sign Up For Free Plan
            </li>

            <li>
              <span className="fw-semibold">Step 3.</span> Click on Download
              Adobe Acrobat
            </li>

            <li>
              <span className="fw-semibold">Step 4.</span> Then check your
              downloads folder to find: reader_en_install.exe (click on it to
              install)
            </li>

            <li>
              <span className="fw-semibold">Step 5.</span> Once the software is
              open...there will be a box that's says "open or drag files here"
            </li>

            <li>
              <span className="fw-semibold">Step 6.</span> Once the PDF file is
              open, click the menu button in the upper left hand corner.... this
              will bring a drop down menu and you will choose "View" then scroll
              over to the sub menu in which you will click on "Read Out Loud",
              then click Activate.
            </li>

            <li>
              <span className="fw-semibold">Step 7.</span> Now go back to the
              Menu button and repeat the previously mentioned process to get
              back to "Read Out Loud" option.
            </li>
          </ul>
          <p>
            You will want to skip over the beginning parts of the book including
            the Table of Contents and simply scroll down to Chapter 1 of the
            book....then click the “Read Out Loud’ button starting from there.
            You can go back to the menu button and repeat the process again to
            get to the Read Out Loud option ..then in the sub menu will now
            include "Pause" and "Stop"
          </p>
          <p className="m-0">
            Can search on YouTube keywords: How To Download Adobe Acrobat Reader
            on Computer Here’s one we found:{" "}
            <a href="http://youtu.be/gcf_bbA-PMs?si=SkNPkOjYPWHipboX">
              https://youtu.be/gcf_bbA-PMs?si=SkNPkOjYPWHipboX
            </a>
          </p>
        </div>
        <div className="bg-light p-4 rounded-3 mt-3">
          <h5>On MOBLIE DEVICE</h5>
          <ul className="list-unstyled fs-6">
            <li>
              <span className="fw-semibold">Step 1.</span> Download the PDFs
              textbooks from our website in which should then appear on your
              device.
            </li>
            <li>
              <span className="fw-semibold">Step 2.</span> Search in Play Store
              or App Store to find the app: Adobe Acrobat Reader
            </li>
            <li>
              <span className="fw-semibold">Step 3.</span> Click INSTALL, then
              once installed click OPEN
            </li>
            <li>
              <span className="fw-semibold">Step 4.</span> Sign In with one of
              the options (It may ask if you want paid plan ...click not NO)
            </li>
            <li>
              <span className="fw-semibold">Step 5.</span> Once on Welcome
              Screen, Go to On Device (tab)
            </li>
            <li>
              <span className="fw-semibold">Step 6.</span> Click on the PDF
              Textbook document and scroll down to Chapter 1
            </li>
            <li>
              <span className="fw-semibold">Step 7.</span> Click 3 dots upper
              left
            </li>
            <li>
              <span className="fw-semibold">Step 8.</span> Scroll down on page
              and click on Read Out Loud
            </li>
          </ul>
          <p className="m-0">
            Can search on YouTube keywords: How To Download Adobe Acrobat Reader
            on Mobile Phones Here’s some we found:
            <ul className="m-0">
              <li>
                ANDROID:{" "}
                <a href="https://youtu.be/LayJXDRxITw?si=0FOoHTC-m2jPsMhG">
                  https://youtu.be/LayJXDRxITw?si=0FOoHTC-m2jPsMhG
                </a>
              </li>
              <li>
                IPHONE (Apple){" "}
                <a href="https://youtu.be/C-aby1o9wvE?si=atmix6r3U9B_WSQ2">
                  https://youtu.be/C-aby1o9wvE?si=atmix6r3U9B_WSQ2
                </a>
              </li>
            </ul>
          </p>
        </div>
      </section>
    </div>
  );
};

export default TextbooksPage;
